export enum HistoryActionType {
  BORROW = 'borrow',
  RETURN = 'return',
  PENDING = 'pending',
  DEPOSIT_BORROW = 'depositBorrow',
  DEPOSIT_RETURN = 'depositReturn',
}
